
import Vue from "vue";

import Spinner from "@/components/Spinner.vue";
import FanIcon from "@/components/icons/FanIcon.vue";
import colorStatus from "@/common/mixins/colorStatus";

export default Vue.extend({
  name: "GCooling",
  mixins: [colorStatus],
  components: { Spinner, FanIcon },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    items() {
      return this.$store.state.modelViewData.tr_summary_status.g;
    },
  },
});
